module.exports = __webpack_public_path__ + "step-rolling.6b0f38b9d097526cf78e1ffe02e599ac.hashedasset.svg";